//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "StyledListing",
	props: {
		listing: Object
	},
	data() {
		return {

		}
	},
	computed: {
		
	}
	
}
